import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "filter" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "filter__title" }, "Фильтры", -1)
const _hoisted_3 = { class: "filter__block" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "hr" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vue_slider = _resolveComponent("vue-slider")
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_accesors_filter = _resolveComponent("accesors-filter")
  const _component_Rating = _resolveComponent("Rating")
  const _component_hotel_services = _resolveComponent("hotel-services")
  const _component_Accordion = _resolveComponent("Accordion")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_Accordion, {
        multiple: true,
        activeIndex: _ctx.activeIndex
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AccordionTab, { header: "Цена" }, {
            default: _withCtx(() => [
              (_ctx.start > 0 && _ctx.showSlider)
                ? (_openBlock(), _createBlock(_component_vue_slider, {
                    key: 0,
                    modelValue: _ctx.price,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.price = $event)),
                    tooltip: 'always',
                    "tooltip-placement": 'bottom',
                    min: _ctx.start,
                    max: _ctx.end,
                    "tooltip-formatter": _ctx.tooltipFormatter,
                    lazy: true,
                    onDragEnd: _cache[2] || (_cache[2] = $event => (_ctx.filterByPrice(_ctx.price[0], _ctx.price[1])))
                  }, null, 8, ["modelValue", "min", "max", "tooltip-formatter"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_AccordionTab, { header: "Поставщики" }, {
            default: _withCtx(() => [
              _createVNode(_component_accesors_filter, {
                filterByAccesor: _ctx.filterByAccesor,
                selectData: _ctx.accessorSelect,
                accessors: _ctx.accessors
              }, null, 8, ["filterByAccesor", "selectData", "accessors"])
            ]),
            _: 1
          }),
          _createVNode(_component_AccordionTab, { header: "Звезды" }, {
            default: _withCtx(() => [
              _createVNode(_component_Rating, {
                modelValue: _ctx.stars,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.stars = $event)),
                cancel: false,
                onChange: _cache[4] || (_cache[4] = $event => (_ctx.filterByStars(_ctx.stars)))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_AccordionTab, { header: "Услуги" }, {
            default: _withCtx(() => [
              _createVNode(_component_hotel_services, { filterByServices: _ctx.filterByServices }, null, 8, ["filterByServices"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["activeIndex"])
    ]),
    _hoisted_4,
    _createVNode("button", {
      type: "button",
      class: "submit-button",
      onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.applyAllFilters(...args)))
    }, " Применить ")
  ]))
}